import Sortable from 'sortablejs';
import bson from 'bson-objectid';

export function create(element, sortableOpts = {}, callbacks = {}) {
  ensureId(element);

  const defaultSortableOpts = {
    ghostClass: 'o-50',
    dragClass: 'shadow-lg',
    animation: 150,
    easing: 'cubic-bezier(1, 0, 0, 1)',
  };

  const callbackOpts = {};

  if (callbacks.onSortStart) {
    callbackOpts.onStart = callbacks.onSortStart;
  }
  if (callbacks.onSortStop) {
    callbackOpts.onEnd = callbacks.onSortStop;
  }
  if (callbacks.onSortUpdate) {
    callbackOpts.onUpdate = callbacks.onSortUpdate;
  }

  const sortable = Sortable.create(element, {
    ...defaultSortableOpts,
    ...sortableOpts,
    ...callbackOpts,
  });

  // store the instance and options on the DOM element in case we need them later
  element.ICMIB_sortable = sortable;
  element.ICMIB_sortableOpts = sortableOpts;
  element.ICMIB_sortableCallbacks = callbacks;
}

function ensureId(element) {
  if (!element.id) {
    element.setAttribute('id', bson.generate());
  }
}

export function reload() {
  // DO NOTHING! doesn't need to be reloaded when items change
}

export function forEach(element, fn) {
  map(element, fn);
}

export function map(element, fn) {
  const selector = element.ICMIB_sortableOpts.draggable;
  const children = element.children;
  const items = selector
    ? Array.from(children).filter(el => el.matches(selector))
    : Array.from(children);
  return items.map(fn);
}

export function serialize(element, fn) {
  return map(element, fn).join('&');
}

export function destroy(element) {
  element.ICMIB_sortable.destroy();
}

// Polyfill matches
if (!Element.prototype.matches) {
  Element.prototype.matches =
    Element.prototype.msMatchesSelector ||
    Element.prototype.webkitMatchesSelector;
}
